import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { userKeys } from './useUsers'
import { userService, type PreferredLanguage } from '../../services/userService'
import { User } from '../../types/user'

export function useUpdatePreferredLanguage() {
  const queryClient = useQueryClient()
  const { i18n } = useTranslation()

  return useMutation({
    mutationFn: (language: PreferredLanguage) => userService.updatePreferredLanguage(language),
    onMutate: async (language) => {
      await queryClient.cancelQueries({ queryKey: userKeys.current })
      const previous = queryClient.getQueryData<User>(userKeys.current)
      if (previous) {
        queryClient.setQueryData<User>(userKeys.current, { ...previous, preferred_language: language })
      }
      const previousLang = i18n.language
      void i18n.changeLanguage(language)
      return { previous, previousLang }
    },
    onError: (_err, _language, context) => {
      if (context?.previous) {
        queryClient.setQueryData(userKeys.current, context.previous)
      }
      if (context?.previousLang) {
        void i18n.changeLanguage(context.previousLang)
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: userKeys.current })
    },
  })
}
